import { put, takeEvery } from "redux-saga/effects";
import { fetchMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  FOLLOWER_COLLEGE_COACH_VIEW_COUNT_START: "FOLLOWER_COLLEGE_COACH_VIEW_COUNT_START",
  FOLLOWER_COLLEGE_COACH_VIEW_COUNT_SUCCESS: "FOLLOWER_COLLEGE_COACH_VIEW_COUNT_SUCCESS",
  FOLLOWER_COLLEGE_COACH_VIEW_COUNT_FAILED: "FOLLOWER_COLLEGE_COACH_VIEW_COUNT_FAILED"
};

// ============================================ Actions ========================================================

export const followerCollegeCoachViewCountStart = data => ({
  type: actionType.FOLLOWER_COLLEGE_COACH_VIEW_COUNT_START,
  payload: data
});

export const followerCollegeCoachViewCountSuccess = data => ({
  type: actionType.FOLLOWER_COLLEGE_COACH_VIEW_COUNT_SUCCESS,
  payload: data
});

export const followerCollegeCoachViewCountFailed = data => ({
  type: actionType.FOLLOWER_COLLEGE_COACH_VIEW_COUNT_FAILED,
  payload: data
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null
};

export default function follwerCollegeCoachViewCountReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.FOLLOWER_COLLEGE_COACH_VIEW_COUNT_START:
      return {
        ...state,
        loading: true
      };

    case actionType.FOLLOWER_COLLEGE_COACH_VIEW_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case actionType.FOLLOWER_COLLEGE_COACH_VIEW_COUNT_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* followerCollegeCoachViewCountSaga(action) {
  try {
    const response = yield fetchMethod(`/api/useracivities/coachViews`,action.payload.variables,'post',true);
    if (response && response.status === 200) {
      yield put(
        followerCollegeCoachViewCountSuccess({data: response.data.response.data})
      );
    } else {
      messagePopup("", "Follower College Coach View Api failed", "error");
      yield put(followerCollegeCoachViewCountFailed("Follower College Coach View Api failed"));
    }
  } catch (error) {
    messagePopup("", "Follower College Coach View Api failed", "error");
    yield put(followerCollegeCoachViewCountFailed("Follower College Coach View Api failed"));
  }
}

export function* watchFollowerCollegeCoachViewCountSaga() {
  yield takeEvery(actionType.FOLLOWER_COLLEGE_COACH_VIEW_COUNT_START, followerCollegeCoachViewCountSaga);
}
